import HeroCarousel from "./Herocarousel";
import Landing from "./Landing";
import Services from  "../pages/Services";
import Whychoose from "../pages/Whychoose";
import CurrentRate from "../pages/CurrentRate";
import FAQ from "../pages/FAQ";
import SEO from "../Components/SEO";

function Home (){
    return(
            <div>
              <SEO 
                title="Industrial Scrap Metal Buyers & Recycling" 
                description="Jaina Enterprises is a leading name in metal supply and industrial scrap recycling. Committed to transparent transactions, complete GST compliance, and best scrap rates."
                keywords="scrap metal buyers, metal supply Delhi NCR, Jaina Enterprises, scrap recycling, industrial scrap, GST compliant scrap metal, iron scrap, copper scrap, aluminium scrap"
              />
            <HeroCarousel />
           <Landing />
              <Whychoose />
              <Services />
              <CurrentRate />
              <FAQ />
            </div>
            )
}
export default Home;